<template>
  <div class="flex justify-between items-end" :class="wrapperClass">
    <div>
      <h2 :class="titleClass">{{ title }}</h2>
      <p v-if="subtitle" class="text-base-content/70 mt-2">{{ subtitle }}</p>
    </div>
    <slot name="action" />
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleClass() {
      return this.compact
        ? 'text-[32px] leading-[1.2] tracking-[-0.01em] font-semibold text-base-content'
        : 'text-[40px] md:text-[32px] leading-[1.2] tracking-[-0.01em] font-semibold text-base-content';
    },
    wrapperClass() {
      return this.compact ? 'mb-8' : 'mb-12';
    }
  }
}
</script>
